import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import WizardPaso3 from '../components/WizardPaso3';
import { Container, Content, Title, Subtitle, Form, FormGroup, Label, Select, DireccionBox, Icon, ButtonGroup, Button } from '../styles/formStyles';
import { getOdontologosPorSucursal } from '../services/api/authService';
import { useAppAgendaContext } from '../context/AppAgendaContext';
import { ButtonContainer } from "../styles/pacienteStyles";

const SeleccionaEspSuc = () => {
  const navigate = useNavigate();
  const { contextData, setContextData, updateOdontRuts, resetOdontRuts, setPaginaOrigen } = useAppAgendaContext();
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState('');
  const [sucursales, setSucursales] = useState([]);
  const [direccion, setDireccion] = useState('');
  const [especialidades, setEspecialidades] = useState([]);
  const [especialidadSeleccionada, setEspecialidadSeleccionada] = useState('');
  const [odontologosPorEspecialidad, setOdontologosPorEspecialidad] = useState({});

  /* URL API */
  const API_BASE_URL = 'https://api-dev.morapavic.cl';

  useEffect(() => {
    const fetchSucursales = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const response = await axios.get(`${API_BASE_URL}/sucursal/listaSucursales`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSucursales(response.data.datos);
      } catch (error) {
        console.error('Error al obtener la lista de sucursales:', error);
      }
    };

    fetchSucursales();
  }, []);

  const handleSucursalChange = async (e) => {
    const sucursalId = e.target.value.trim();
    if (!sucursalId || isNaN(parseInt(sucursalId))) {
      console.error("❌ Error: `sucursalId` no es válido:", sucursalId);
      return;
    }

    const sucursalSeleccionadaObj = sucursales.find((suc) => suc.sucId === parseInt(sucursalId));
    setSucursalSeleccionada(sucursalId);

    if (sucursalSeleccionadaObj) {
      setDireccion(sucursalSeleccionadaObj.sucDireccion);

      setContextData((prev) => ({
        ...prev,
        sucursalId,
        sucursalNombre: sucursalSeleccionadaObj.sucNombre || 'Sin información',
      }));
    } else {
      setDireccion('');
      setContextData((prev) => ({
        ...prev,
        sucursalId: null,
        sucursalNombre: null,
      }));
    }

    try {
      const respuesta = await getOdontologosPorSucursal(sucursalId);
      if (respuesta?.datos?.length > 0) {
        const especialidadesMap = respuesta.datos.reduce((acc, item) => {
          if (item.odontEspecialidadMain) {
            if (!acc[item.odontEspecialidadMain]) {
              acc[item.odontEspecialidadMain] = [];
            }
            acc[item.odontEspecialidadMain].push(item.odontRut);
          }
          return acc;
        }, {});

        setEspecialidades(Object.keys(especialidadesMap).sort());
        setOdontologosPorEspecialidad(especialidadesMap);
      } else {
        setEspecialidades([]);
        setOdontologosPorEspecialidad({});
      }
    } catch (error) {
      console.error("❌ Error al obtener odontólogos:", error.response?.data || error.message);
      setEspecialidades([]);
      setOdontologosPorEspecialidad({});
    }
  };

  useEffect(() => {
    /* console.log('🧹 Reseteando odontRuts solo si se está iniciando un nuevo flujo...'); */
    if (!contextData.odontRuts?.length) {
      resetOdontRuts();
    }
  }, []);

  const handleEspecialidadChange = (e) => {
    const especialidad = e.target.value;
    setEspecialidadSeleccionada(especialidad);
    const odontRuts = odontologosPorEspecialidad[especialidad] || [];

    if (typeof updateOdontRuts === 'function') {
      resetOdontRuts();
      updateOdontRuts(odontRuts);
      /* console.log("✅ OdontRuts actualizados correctamente (desde Especialidad):", odontRuts); */
    } else {
      console.error("❌ Error: `updateOdontRuts` no está definido correctamente.");
    }
  };

  const handleSiguienteClick = () => {
    if (sucursalSeleccionada) {
      setPaginaOrigen('SeleccionaEspSuc');
      setContextData((prev) => ({
        ...prev,
        paginaOrigen: 'SeleccionaEspSuc',
      }));
      navigate('/SeleccionaFecHora');
    } else {
      console.error('Error: Sucursal no seleccionada.');
    }
  };

  return (
    <Container>
      <WizardPaso3 />
      <Content>
        <Title>Seleccionar Sucursal y <strong>Especialidad</strong></Title>
        <Subtitle>Selecciona la sucursal de nuestra clínica que te quede más cómoda</Subtitle>
  
        <Form>
          <FormGroup>
            <Label htmlFor="clinica"><strong>Clínica Dental</strong></Label>
            <Select id="clinica" onChange={handleSucursalChange} defaultValue="">
              <option value="">Seleccione Sucursal</option>
              {sucursales.map(sucursal => (
                <option key={sucursal.sucId} value={sucursal.sucId}>
                  {sucursal.sucNombre}
                </option>
              ))}
            </Select>
          </FormGroup>
          <FormGroup>
            <Label htmlFor="especialidad"><strong>Especialidad</strong></Label>
            <Select id="especialidad" value={especialidadSeleccionada} onChange={handleEspecialidadChange} disabled={especialidades.length === 0}>
              <option value="">Seleccione la especialidad</option>
              {especialidades.map((especialidad, index) => (
                <option key={index} value={especialidad}>
                  {especialidad}
                </option>
              ))}
            </Select>
          </FormGroup>
        </Form>
  
        <DireccionBox>
          <Icon className="fas fa-map-marker-alt" />
          <div>
            <strong>Dirección</strong>
            <p>{direccion || 'Selecciona una sucursal para ver la dirección'}</p>
          </div>
        </DireccionBox>
  
        {/* 🔹 Movemos la botonera dentro del `Content` para que forme parte del flujo */}
        <ButtonContainer>
          <Button type="button" secondary onClick={() => navigate('/SeleccionaTipoHora')}>
            Volver
          </Button>
          <Button type="button" className="btn-cyan" onClick={handleSiguienteClick} disabled={!especialidadSeleccionada}>
            Siguiente
          </Button>
        </ButtonContainer>
        
      </Content>
    </Container>
  );
};

export default SeleccionaEspSuc;